import React from 'react'
import { Typography, Box, TextField, useTheme } from '@mui/material'
import useCustomStyles from '../../../../../utils/hooks/CustomStylesHook'
import { TRICOG_ROLES } from '../../../../opd/components/devices/Constant'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '22px',
    padding: '16px',
    border: '1px solid #ccc',
    borderRadius: '8px',
  },
  pdfPreview: {
    width: '100%',
    height: '400px',
    border: '1px solid #ccc',
    borderRadius: '4px',
  },
}

interface UploadFormProps {
  role?: string
  name?: string
  interpretation?: string
  pdfFileUrl?: string
}

const UploadView = ({ data }: { data?: UploadFormProps }) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const getRoleLabel = (value: string) =>
    TRICOG_ROLES.find((role) => role.value === value)?.label || value

  return (
    <Box className={classes.container}>
      <Typography variant='h6'>Tricog Details</Typography>

      <TextField
        size='small'
        label='Role'
        value={getRoleLabel(data?.role || '')}
        variant='outlined'
        fullWidth
        InputProps={{ readOnly: true }}
      />

      <TextField
        size='small'
        label={getRoleLabel(data?.role || '')}
        value={data?.name || ''}
        variant='outlined'
        fullWidth
        InputProps={{ readOnly: true }}
      />

      <Typography fontSize='13px' fontWeight={500}>
        ECG Report
      </Typography>

      {data?.pdfFileUrl && (
        <iframe
          src={data?.pdfFileUrl}
          title='PDF Preview'
          className={classes.pdfPreview}
        />
      )}

      <TextField
        label='Interpretation'
        name='interpretation'
        multiline
        minRows={3}
        value={data?.interpretation || ''}
        variant='outlined'
        fullWidth
        InputProps={{ readOnly: true }}
      />
    </Box>
  )
}

export default UploadView
